<template>
  <v-row justify="end" class="mr-0">
    <v-dialog v-model="editItemDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t(translation+'.edit')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-on:submit.prevent>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.name"
                    :label="$t(translation+'.name')+'*'" required
                    :rules="rules.required_length"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-combobox
                    v-model="type"
                    :items="types"
                    item-text="value"
                    @change="form.type = type.value"
                    :label="$t(translation+'.type')+'*'" required
                    :rules="rules.required"
                  />
                </v-col>
                <v-col cols="6">
                  <v-file-input
                    v-model="form.image"
                    accept=".jpg,.png,.jpeg"
                    :label="$t(translation+'.uploadWysWyg') + '*'" required
                    prepend-icon="mdi-paperclip"
                    :rules="rules.required_image"
                  >
                    <template v-slot:selection="{ text }">
                      {{ text }}
                    </template>
                  </v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-combobox readonly @click="openChooseCategoryDialog" item-text="name" multiple
                              :label="$t(translation+'.categories')+'*'" v-model="form.categories"/>
                </v-col>
                <v-col cols="12" :hidden="!(type !== null && type.id === 3)">
                  <v-menu
                    ref="menu"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="form.dates"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-combobox
                        v-model="form.dates"
                        multiple
                        label="Datumi"
                        readonly
                        v-on="on"
                      ></v-combobox>
                    </template>
                    <v-date-picker :min="new Date().toISOString().slice(0,10)" v-model="form.dates" multiple no-title
                                   scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu1 = false">Zatvori</v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(form.dates)">Potvrdi</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="8" :hidden="!(type !== null && (type.id === 2 || type.id === 3))">
                  <v-file-input
                    v-model="form.wyswygimg"
                    accept=".jpg,.png,.jpeg"
                    :label="'Slika ' + (type != null && type.id !== 1 ? type.value : '')" required
                    prepend-icon="mdi-paperclip"
                    :rules="rules.wyswygimg"
                  >
                    <template v-slot:selection="{ text }">
                      {{ text }}
                    </template>
                  </v-file-input>
                </v-col>
                <v-col cols="4">
                  <v-checkbox
                    v-model="form.remove"
                    :hidden="!form.page_content_details.includes('<img')"
                    label="Ukloni staru sliku"/>
                </v-col>
                <v-col cols="12" :hidden="!(type !== null && (type.id === 2 || type.id === 3))">
                  <tiptap-vuetify
                    v-model="form.page_content"
                    :extensions="extensions"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{$t('required_fields')}}</small>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text :disabled="loading" @click="closeDialog">{{$t('close')}}</v-btn>
          <v-btn color="blue darken-1" text :loading="loading" @click="edit(api,dataForModal)">
            {{$t('edit')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <choose-categories
      :selectedItems="form.categories"
      :chooseCategoryDialog="chooseCategoryDialog"
      :campaign="false"
      @close="chooseCategoryDialog=false"
      @editEmit="editEmit"/>
  </v-row>
</template>

<script>
  import {edit, findById, readCountriesActive} from "../../statics/DataTableFunctions";
  import axios from "axios";
  import ChooseCategory from "../categories/ChooseCategory";
  import {
    TiptapVuetify,
    CodeBlock,
    Image,
    Heading,
    Resize,
    Bold,
    Italic,
    Strike,
    Underline,
    Code,
    Paragraph,
    BulletList,
    OrderedList,
    ListItem,
    Link,
    Blockquote,
    HardBreak,
    HorizontalRule,
    History
  } from 'tiptap-vuetify'

  export default {
    props: {
      editItemDialog: false,
      dataForModal: null,
    },
    components: {
      'choose-categories': ChooseCategory,
      TiptapVuetify
    },
    name: "EditSlider",
    data() {
      return {
        initFinished: false,
        initWatcher: false,
        translation: 'sliders',
        api: 'sliders',
        type: null,
        menu1: false,
        menu2: false,
        loading: false,
        chooseCategoryDialog: false,
        deleteAll: null,
        initControls: null,
        extensions: [
          History,
          Blockquote,
          Link,
          Underline,
          Strike,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3]
            }
          }],
          Bold,
          CodeBlock,
          HorizontalRule,
          Paragraph,
          HardBreak
        ],
        form: {
          name: '',
          page_content: '',
          notification_text: '',
          type: '',
          push_notification: false,
          dates: [],
          remove: '',
          categories: [],
          image: null,
          wyswygimg: null,
          page_content_details: ''
        },
        config: {
          toolbarButtons: {
            'moreText': {
              'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
            },
            'moreParagraph': {
              'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
            },
            'moreRich': {
              'buttons': ['insertLink', 'insertImage', 'insertTable', 'emoticons']
            },
            'moreMisc': {
              'buttons': ['undo', 'redo', 'fullscreen', 'selectAll'],
              'align': 'right',
              'buttonsVisible': 2
            },
          },
          charCounterCount: false,
          placeholderText: 'Edit Your Content Here!',
          imageUpload: true,
          imageDefaultAlign: 'left',
          imageDefaultDisplay: 'inline-block',
          // Set max image size to 5MB.
          imageMaxSize: 5 * 1024 * 1024,
          // Allow to upload PNG and JPG.
          imageAllowedTypes: ['jpeg', 'jpg', 'png'],
          events: {
            'initialized': function () {
              console.log('initialized', this)
            },
            'image.beforeUpload': function (images) {
              const data = new FormData();
              data.append('image', images[0]);
              axios.post('api/sliderWysWygImages', data, {
                headers: {
                  'accept': 'application/json',
                  'Accept-Language': 'en-US,en;q=0.8',
                  'Content-Type': `multipart/form-data`,
                }
              }).then(res => {
                this.image.insert(res.data, null, null, this.image.get());
              }).catch(err => {
              });
              return false;
            }
          }
        },
        types: [
          {id: 1, value: 'Slika'},
          {id: 2, value: 'Promocija'},
          {id: 3, value: 'Seminar'},
        ],
        rules: {
          required: [
            v => !!v || this.$t('validation.field'),
          ],
          required_array: [
            v => (v.id != null || v.id !== undefined) || v.length > 0 || this.$t(this.translation + '.choose'),
          ],
          required_notification: [
            v => !!v || this.$t('validation.field'),
            v => !!v || this.form.push_notification === true || this.$t(this.translation + '.notification'),
          ],
          required_length: [
            v => !!v || this.$t('validation.field'),
            v => v === '' || v.length > 1 || this.$t(this.translation + '.validation')
          ],
          required_image: [
            v => {
              if (v) return (this.form.image.name.split('.')[1] === 'jpg' || this.form.image.name.split('.')[1] === 'jepg' || this.form.image.name.split('.')[1] === 'png') || this.$t(this.translation + '.image_validation');
              else return true;
            },
          ],
        },
        snackbar: {
          color: 'success',
          show: false,
          text: '',
          timeout: 3000,
        },
      }
    },
    methods: {
      editEmit(data) {
        this.form.categories = data;
      },
      changeDates() {
        if (this.form.dateFrom >= this.form.dateTo) {
          this.form.dateTo = null;
        }
      },
      openChooseCategoryDialog() {
        this.chooseCategoryDialog = true;
      },
      chooseCategoryEmit(data) {
        this.form.categories = data;
        this.chooseCategoryDialog = false;
      },
      closeChooseCategoryDialog(data) {
        this.chooseCategoryDialog = false;
      },
      edit() {
        if (!this.$refs.form.validate()) {
          this.snackbar.color = 'error';
          this.snackbar.text = this.$t('snackbar_required');
          this.snackbar.show = true;
          return;
        }
        this.loading = true;
        let formData = new FormData();
        formData.append('name', this.form.name);
        formData.append('type', this.type.value);
        formData.append('image', this.form.image == null ? "" : this.form.image);
        formData.append('dates', JSON.stringify(this.form.dates));
        formData.append('page_content', this.form.page_content);
        formData.append('notification_text', this.form.notification_text);
        formData.append('remove', this.form.remove);
        formData.append('wyswygimg', this.form.wyswygimg == null ? 'null' : this.form.wyswygimg);
        formData.append("categories", JSON.stringify(this.form.categories));
        axios.post('api/sliders/' + this.dataForModal.id, formData, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json;'
          }
        }).then((response) => {
          this.$emit('editEmit', response.data)
          this.snackbar.color = 'success';
          this.snackbar.text = this.$t('edit_success');
          this.snackbar.show = true;
          this.closeDialog();
          this.loading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.loading = false
            this.$swal.fire({
              type: 'info',
              title: "Info",
              text: this.$t('validation.session'),
            })
            this.$router.push('/login')
          }else if(error.response.status == 422){
            this.validationErrors = error.response.data.errors;
            let message = '';
            for (let key in this.validationErrors) {
              let temp = this.validationErrors[key];
              for (let i = 0; i < temp.length; i++) {
                message += this.$t('errorValidations.' + temp[i].replace(/ /g, "_").slice(0, -1))
              }
            }
            this.loading = false;
            this.$swal.fire({
              type: 'error',
              title: this.$t('validation.error'),
              text: message,
            })
          }
          else {
            this.loading = false;
            this.$swal.fire({
              type: 'error',
              title: this.$t('validation.error'),
              text: this.$t('validation.error'),
            })
          }
        })
      },
      readCountriesActive,
      closeDialog() {
        this.type = null;
        this.form = {
          name: '',
          page_content: '',
          notification_text: '',
          type: '',
          push_notification: false,
          dates: [],
          categories: [],
          wyswygimg: null,
          image: null,
        };
        this.$refs.form.resetValidation()
        this.$emit('close')
      },
    },
    watch: {
      editItemDialog: function (val) {
        if (val) {
        }
      },
    },
    created() {
      for (let i = 0; i < this.types.length; i++) {
        if (this.types[i].value === this.dataForModal.type) {
          this.type = this.types[i];
        }
      }
      this.form = {
        name: this.dataForModal.name,
        page_content: this.dataForModal.page_content == null ? "" : this.dataForModal.page_content,
        dates: this.dataForModal.available_dates === [] ? [] : this.dataForModal.available_dates,
        notification_text: this.dataForModal.notification_text == null ? "" : this.dataForModal.notification_text,
        categories: this.dataForModal.categories,
        remove: false,
        page_content_details: this.dataForModal.page_content_details == null ? "" : this.dataForModal.page_content_details
      };
      for (let i = 0; i < this.types.length; i++) {
        if (this.types[i].value === this.dataForModal.type) {
          this.form.type = this.types[i];
        }
      }
      this.image = null;
    },
  }
</script>

<style scoped/>
